const initialState = {
    mapId: null,
    map: null,
    editMode: false,

    markers: {},
    markersGroup: null,
    pathsGroup: null,

    arrowLayer: null,
    arrowInterval: null,

    dragging: null,

    animatedImages: {},
    animatedImagesGroup: null,

    creatingPoint: null,
    showEmptyOverlay: false,
};

export const state = {...initialState};

export function resetState() {
    Object.assign(state, structuredClone(initialState));
}
